/* eslint-disable no-console */

import {register} from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                    'For more details, visit https://goo.gl/AFskqB'
            )
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updated() {
            console.log('An update is available, please refresh.')
            try {
                caches.keys().then(names => {
                    for (let name of names) {
                        caches.delete(name)
                    }
                })
            } catch (e) {
                console.log(e)
            }
            // updated(reg) {
            // if (reg.waiting) {
            //     Vue.prototype.$snackbar.show({
            //         type: 'SUCCESS',
            //         text: 'A new version is available, ' +
            //             '<a href="#" id="refresh-worker" class="text-semi-bold">click here to update</button>.',
            //         duration: 1000000
            //     })
            //
            //     Vue.nextTick(() => {
            //         const btn = document.getElementById('refresh-worker')
            //         if (btn) {
            //             btn.onclick = function(event) {
            //                 event.preventDefault()
            //                 reg.waiting.postMessage({action: 'skipWaiting'})
            //                 Vue.prototype.$snackbar.hide()
            //             }
            //         }
            //     })
            // }
            // }
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        }
    })

    let isRefreshing = false
    navigator.serviceWorker.addEventListener('controllerchange', function() {
        if (isRefreshing) {
            return
        }
        window.location.reload()
        isRefreshing = true
    })
}
